import { Percentage } from '@sparkdotfi/common-universal'
import { z } from 'zod'

export const SlippageInputType = z.enum(['button', 'input'])
export type SlippageInputType = z.infer<typeof SlippageInputType>

export const ActionSettingsSchema = z.object({
  slippage: z.object({
    type: SlippageInputType,
    value: z.string().refine(
      (value) => {
        const slippage = Number.parseFloat(value)
        return !Number.isNaN(slippage) && slippage >= 0.01 && slippage < 50
      },
      {
        message: 'Value has to be greater than 0.01 and less than 50',
      },
    ),
  }),
})
export type ActionSettingsSchema = z.infer<typeof ActionSettingsSchema>

export function formatPercentageFormValue(value: Percentage): string {
  const percentageFormatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 6,
    minimumFractionDigits: 0,
  })
  return percentageFormatter.format(value.times(100).toNumber())
}
